import {flatten} from 'lodash';

export default function (styles: mapboxgl.Style[]) {
    const output: mapboxgl.Style[][] = [];

    let i = 0;
    while (i < styles.length) {
        const groupStyles = [styles[i++]];
        while (i < styles.length && !isBasemap(styles[i])) {
            groupStyles.push(styles[i++]);
        }

        const groupSplitStyles = groupStyles.map(splitStyle);

        const groupTopStyles = [];
        const groupBottomStyles = [];
        for (const [bottomStyle, topStyle] of groupSplitStyles) {
            if (bottomStyle) groupBottomStyles.push(bottomStyle);
            if (topStyle) groupTopStyles.push(topStyle);
        }

        output.push(groupBottomStyles, groupTopStyles);
    }

    return flatten(output);
}

function splitStyle(style: mapboxgl.Style) {
    if (!style.layers) return [style, null];

    const lengthThreshold = Math.max(2, style.layers.length * 0.02);

    const bottomStyle = {...style, layers: []} as mapboxgl.Style;
    const topStyle = {...style, layers: []} as mapboxgl.Style;

    for (const layer of style.layers.slice().reverse()) {
        if (bottomStyle.layers!.length > lengthThreshold) {
            bottomStyle.layers!.unshift(layer);
        } else if (layer.type !== 'symbol' && layer.type !== 'circle') {
            bottomStyle.layers!.unshift(layer);
        } else {
            topStyle.layers!.unshift(layer);
        }
    }

    return [bottomStyle, topStyle];
}

function isBasemap(style: mapboxgl.Style) {
    const type: Partial<LayerType> | undefined = style.metadata;
    return type && type.basemap;
}
